import { UserGroupIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router";
import useSWR from "swr";
import { InfoCard } from "../components/Displays";
import { useUserStore } from "../context";
import { useApi } from "../hooks";
import { hasRole } from "../utils/helpers";
import constants from "../utils/constants";

export default function Dashboard() {
  const { currentUser } = useUserStore();
  const { fetch } = useApi();

  const navigate = useNavigate();

  const { data, error, isLoading, isValidating, mutate } = useSWR(
    hasRole(currentUser, constants.ROLE_NAMES.SYS_ADMIN) ? "admin/dashboardInfo" : undefined,
    fetch
  );

  return (
    <div className="-m-4">
      {/* Header */}
      <div className="bg-primaryColor w-full h-[20vh] p-4 text-lg">
        <h3 className="text-white font-bold">
          Welcome, {currentUser.firstName}
        </h3>
      </div>
      {/* Cards */}
      {hasRole(currentUser, constants.ROLE_NAMES.SYS_ADMIN) && (
        <div className="flex flex-wrap p-4">
          <InfoCard
            title="Manage Users"
            count={data?.userCount}
            onClick={() => navigate("/users")}
            Icon={UserGroupIcon}
            isLoading={isLoading}
          />
        </div>
      )}
    </div>
  );
}
